import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './ErrorModal.module.scss';
import ModalBase from '../ModalBase/ModalBase';
import { errorImg } from '@assets/index';
import { AuthButton } from '@components/index';
const ErrorModal = ({ error, onClick }) => {
    return (_jsxs(ModalBase, Object.assign({ onClose: onClick, modifier: "error" }, { children: [_jsxs("header", Object.assign({ className: styles.header }, { children: [_jsx("img", { src: errorImg, alt: "Error icon", className: styles.img }), _jsx("h4", Object.assign({ className: styles.title }, { children: "Error" }))] })), _jsx("p", Object.assign({ className: styles.text }, { children: error })), _jsx("div", Object.assign({ className: styles.buttonWrapper }, { children: _jsx(AuthButton, { text: "Try again", type: "button", onClick: onClick }) }))] })));
};
export default ErrorModal;
